import { Dispatch } from "@reduxjs/toolkit";
import { CouponsToMyChargeRequestId, InMyChargeEmployeeContractsRequestFilter, InMyChargeEmployeeContractsRequestId, InMyChargeEmployeeDocumentsRequestFilter, InMyChargeEmployeeDocumentsRequestId, InMyChargeEmployeePaymentSlipsRequestFilter, InMyChargeEmployeePaymentSlipsRequestId, LoansToMyChargeRequestId, resetContactsData, setApprovalEmployeesLoading, setApprovalEmployeesPartial, setApprovalEmployeesReset, setApprovalGroupsCompaniesLoading, setApprovalResponsablesLoading, setApprovalResponsablesPartial, setApprovalResponsablesReset, setCalendarEvents, setCompanyEmployeesLoading, setCouponsToApprove, setCouponsToMyChargeEmployeesHistoryPartial, setCouponsToMyChargeEmployeesLoading, setCouponsToMyChargeEmployeesPartial, setCouponsToMyChargeEmployeesReset, setCouponsTypes, setCouponsTypesError, setCouponsTypesLoading, setCouponsTypesRequestLoading, setCouponsTypesRequestResult, setEmployeeCouponIdRequested, setEmployeesVacationsResumeLoading, setInMyChargeDocumentsLoading, setInMyChargeEmployeeContractsLoading, setInMyChargeEmployeeContractsReset, setInMyChargeEmployeeDocumentsReset, setInMyChargeEmployeePaymentSlipsLoading, setInMyChargeEmployeePaymentSlipsReset, setLoadingContacts, setLoansToMyChargeEmployeesLoading } from "./userRequestsSlice";
import { getCouponsTypesRequest, getCouponsTypesUsedByEmployeeRequest, getEmployeeCoupons, getToMyChargeCouponsHistory, getToMyChargePenddingCoupons, sendEmailRequestCouponResponsibles, setCouponsHasAttachmentFlag, setCouponsTypesRequest } from "../../../api/s10DocumentsApi";
import { S10ContactsRequest, S10CouponsToMyChargePartial, S10CouponsTypesResponse, S10CouponsVacationRangeRequest, S10SendRequestCouponResponsibles } from "../../../interfaces/s10Employees.interface";
import { getApprovalGroupsCompanies, getEmployeesAdditionalDataById, getCompanyEmployees, getContactsS10, getUsersEmailsByCodes, setAproveCouponERP, setEmployeesContractsData, setEmployeesPaymentSlipsData, setEmployeesDocumentsData, getCompanyEmployeesVacationsResume, getCompanyEmployeesVacationsDetails, getLoansToApprove, getAssignedCompanies, getYearHolidays } from "../../../api/signalApi";
import { store } from "../../store";
import { deleteGroupIdRequest } from "../../../api/fileStorage";
import { getApprovalEmployees, getApprovalResponsables, getNotificationGroupEmployees } from "../../../api/s10OrganizationApi";
import { ApprovalEmployeesPartial, ApprovalResponsablesPartial, CompanyEmployees } from "../../../interfaces/auth.interface";
import { APPROVAL_EMPLOYEES, APPROVAL_RESPONSABLES, COUPONS_TO_MY_CHARGE_HISTORY_ONE, COUPONS_TO_MY_CHARGE_HISTORY_TWO, PENDING_COUPONS_EMPLOYEES_HISTORY_ONE, PENDING_COUPONS_EMPLOYEES_HISTORY_THREE, PENDING_COUPONS_EMPLOYEES_HISTORY_TWO, PENDING_COUPONS_EMPLOYEES_ONE, PENDING_COUPONS_EMPLOYEES_THREE, PENDING_COUPONS_EMPLOYEES_TWO } from "../../../constants/signalRequestConsts";
import { desgloseEventsByDay } from "../../../utils/generate-range-date";
import { EmployeCoupons } from "../../../interfaces/employeeDocuments.interface";
import { getDatestring } from "../../../utils/date";


export const getCouponsTypes = (processType: 1 | 0 | -1, isActive: 1 | 0 | -1 = 1) => {
    return async (dispatch: Dispatch) => {
        dispatch(setCouponsTypesLoading(true));
        dispatch(setCouponsTypesError(""));
        const resp: S10CouponsTypesResponse[] = await getCouponsTypesRequest(processType, isActive);
        if (resp.length === 0) {
            const errorMsg = "error no fue posible obtener los tipos de cupon"
            dispatch(setCouponsTypesError(errorMsg));
            return;
        }
        dispatch(setCouponsTypes(resp));
        // dispatch(setCouponsTypesLoading(false));
    }
}

export const getCouponsTypesUsedByEmployees = () => {
    return async (dispatch: Dispatch) => {
        dispatch(setCouponsTypesLoading(true));
        dispatch(setCouponsTypesError(""));
        const resp: S10CouponsTypesResponse[] = await getCouponsTypesUsedByEmployeeRequest();
        if (resp.length === 0) {
            const errorMsg = "error no fue posible obtener los tipos de cupon"
            dispatch(setCouponsTypesError(errorMsg));
            return;
        }
        dispatch(setCouponsTypes(resp));
        dispatch(setCouponsTypesLoading(false));
    }
}

export const requestCouponRange = (
    couponData: S10CouponsTypesResponse, 
    startDate: string, 
    endDate: string, 
    comment: string, 
    filesGroup: string = "", 
    filesCount: number = 0,
    CompanyRUC?: string,
    CompanyName?: string,
) => {
    const authCompanySelectedState = store.getState().auth.companyselected;
    return async (dispatch: Dispatch) => {
        dispatch(setCouponsTypesRequestLoading(true));
        dispatch(setCouponsTypesError(""));
        const data: S10CouponsVacationRangeRequest = {
            CouponId: couponData.CouponId,
            UseType: couponData.UseType,
            // EmployeeCouponId: couponData.EmployeeCouponId,
            EmployeeCode: authCompanySelectedState?.Code as any,
            StartDate: startDate,
            EndDate: endDate,
            Comments: comment,
            FilesGroup: filesGroup,
            FilesCount: filesCount,
            CompanyRUC,
            CompanyName,
        }
        const resp  = await setCouponsTypesRequest(data);
        if (!resp || resp.Type !== 0) {
            const errorMsg = resp?.Message || "error no fue posible solicitar el cupón"
            dispatch(setCouponsTypesError(errorMsg));
            if (filesGroup) {
                await deleteGroupIdRequest(filesGroup);
            }
            return;
        }
        let promises = [];
        if (filesGroup && filesCount > 0) {
            const useEmployeeCouponId = resp.Value.UseEmployeeCouponId as number;
            promises.push(setCouponsHasAttachmentFlag(useEmployeeCouponId, true));
        }
        dispatch(setCouponsTypesRequestResult(resp));
        if (resp?.Value?.Responsables?.length) {
            promises.push(getUsersEmailsByCodes(resp.Value.Responsables));
        }
        await Promise.all(promises);
        dispatch(setCouponsTypesRequestLoading(false));
    }
}

export const sendEmailCouponNotification = () => {
    console.log("sendEmailCouponNotification")
    const authCompanySelectedState = store.getState().auth.companyselected;
    const authSessionDataState = store.getState().auth.sessionData;
	const {useEmployeeCouponResponsablesData, useEmployeeCouponIdRequested} = store.getState().userRequests.requestCoupon;
    const employeeAdditionalData = useEmployeeCouponResponsablesData
                                    .find(e => e.CodIdentificador === authCompanySelectedState?.Code);
    const responsiblesData = useEmployeeCouponResponsablesData
                                .filter(e => e.CodIdentificador !== authCompanySelectedState?.Code);
    return async (dispatch: Dispatch) => {
        if (!useEmployeeCouponIdRequested) {
            return;
        }
        const data: S10SendRequestCouponResponsibles = {
            UseEmployeeCouponId: useEmployeeCouponIdRequested as any,
            EmployeeInfo: {
                Corporation: authCompanySelectedState?.Name as any,
                CompanyName: employeeAdditionalData?.Empresa as any,
                FullName: `${authSessionDataState?.FullName} (${authSessionDataState?.UserName})`
            },
            ToEmails: responsiblesData.map(u => u.EMail),
        }
        const resp  = await sendEmailRequestCouponResponsibles(data);
        dispatch(setEmployeeCouponIdRequested(null));
        if (!resp || resp.Type !== 0) {
            const errorMsg = resp?.Message || "error no fue posible notificar por email"
            dispatch(setCouponsTypesError(errorMsg));
            return;
        }
    }
}

export const searchContacts = (props: S10ContactsRequest) => {
    return async (dispatch: Dispatch) => {
        dispatch(resetContactsData());
        dispatch(setLoadingContacts(true));
        await getContactsS10(props);
    }
}

export const searchApprovalGroupsCompanies = () => {
    return async (dispatch: Dispatch) => {
        dispatch(setApprovalGroupsCompaniesLoading(true));
        await getApprovalGroupsCompanies()
    }
}

export const searchAssignedCompanies = () => {
    return async (dispatch: Dispatch) => {
        dispatch(setApprovalGroupsCompaniesLoading(true));
        await getAssignedCompanies()
    }
}

export const searchApprovalGroupsResponsables = (approvalGroup: string) => {
    return async (dispatch: Dispatch) => {
        dispatch(setApprovalResponsablesLoading(true));
        dispatch(setApprovalResponsablesReset());
        const result = await getApprovalResponsables(approvalGroup);
        if (result?.data?.length !== undefined) {
            const responsablesPartial = result.data as ApprovalResponsablesPartial[]
            dispatch(setApprovalResponsablesPartial(responsablesPartial));
            await getEmployeesAdditionalDataById(APPROVAL_RESPONSABLES, responsablesPartial
                                .map(r => r.ApprovalGroupResponsableCode))
        } else {
            dispatch(setApprovalResponsablesLoading(false));
        }
    }
}


export const searchCompanyEmployees = (ruc: string, pageSize: number, pageNumber: number, description: string = "") => {
    return async (dispatch: Dispatch) => {
        dispatch(setCompanyEmployeesLoading(true));
        await getCompanyEmployees(ruc, pageSize, pageNumber, description);
    }
}

export const searchCompanyEmployeesVacationsResume = (employeeCodes: string, ruc: string, pageSize: number, pageNumber: number, description: string = "") => {
    return async (dispatch: Dispatch) => {
        dispatch(setCompanyEmployeesLoading(true));
        await getCompanyEmployeesVacationsResume(employeeCodes, ruc, pageSize, pageNumber, description);
    }
}


export const searchLoansToApprove = (
    requestId: LoansToMyChargeRequestId,
    employeeCodes: string, 
    ruc: string, 
	status: 0 | 1 | 2,
    pageSize: number, 
    pageNumber: number, 
    description: string = ""
) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoansToMyChargeEmployeesLoading({requestId, loading: true}));
        await getLoansToApprove(requestId,employeeCodes, ruc, status, pageSize, pageNumber, description);
    }
}

export const searchCompanyEmployeeVacationsDetails = (codes: string, ruc: string, description: string = "", pageSize: number, pageNumber: number, ) => {
    return async (dispatch: Dispatch) => {
        dispatch(setEmployeesVacationsResumeLoading(true));
        if (codes.length === 0) {
            dispatch(setEmployeesVacationsResumeLoading(false));
            return;
        }
        await getCompanyEmployeesVacationsDetails(codes, ruc, description, pageSize, pageNumber);
    }
}

export const searchApprovalGroupsEmployees = (approvalGroup: string) => {
    return async (dispatch: Dispatch) => {
        dispatch(setApprovalEmployeesReset());
        dispatch(setApprovalEmployeesLoading(true));
        const result = await getApprovalEmployees(approvalGroup);
        if (result?.data?.length) {
            const responsablesPartial = result.data as ApprovalEmployeesPartial[]
            dispatch(setApprovalEmployeesPartial(responsablesPartial));
            await getEmployeesAdditionalDataById(APPROVAL_EMPLOYEES, responsablesPartial
                                .map(r => r.EmployeeCode))
        } else {
            dispatch(setApprovalEmployeesLoading(false));
        }
    }
}


export const searchNotificationGroupsEmployees = (notificationGroupId: number) => {
    return async (dispatch: Dispatch) => {
        dispatch(setApprovalEmployeesReset());
        dispatch(setApprovalEmployeesLoading(true));
        const result = await getNotificationGroupEmployees(notificationGroupId);
        if (result?.data?.length) {
            const responsablesPartial = result.data as ApprovalEmployeesPartial[]
            dispatch(setApprovalEmployeesPartial(responsablesPartial));
            await getEmployeesAdditionalDataById(APPROVAL_EMPLOYEES, responsablesPartial
                                .map(r => r.EmployeeCode))
        } else {
            dispatch(setApprovalEmployeesLoading(false));
        }
    }
}

export const searchCouponsToMyChargeEmployees = (requestId: CouponsToMyChargeRequestId) => {
    return async (dispatch: Dispatch) => {
        dispatch(setCouponsToMyChargeEmployeesReset(requestId));
        dispatch(setCouponsToMyChargeEmployeesLoading({loading: true, requestId}));
        const result = await getToMyChargePenddingCoupons();
        if (result) {
            dispatch(setCouponsToMyChargeEmployeesPartial({requestId, data: result}));
            
            const newRequestId = requestId === COUPONS_TO_MY_CHARGE_HISTORY_ONE
                ? PENDING_COUPONS_EMPLOYEES_ONE
                :  requestId === COUPONS_TO_MY_CHARGE_HISTORY_TWO 
                    ? PENDING_COUPONS_EMPLOYEES_TWO
                    : PENDING_COUPONS_EMPLOYEES_THREE;
            await getEmployeesAdditionalDataById(
                newRequestId, 
                result.map(r => r.EmployeeCode,    
            ))
        } else {
            dispatch(setCouponsToMyChargeEmployeesLoading({loading: false, requestId}));
        }
    }
}


export const searchCouponsToMyChargeEmployeesHistory = (
    requestId: CouponsToMyChargeRequestId, 
    status: string, 
    couponType: string, 
    quantityPerPage: number, 
    page: number
) => {
    return async (dispatch: Dispatch) => {
        dispatch(setCouponsToMyChargeEmployeesReset(requestId));
        dispatch(setCouponsToMyChargeEmployeesLoading({loading: true, requestId,}));
        const result = await getToMyChargeCouponsHistory(status, couponType, requestId, quantityPerPage, page);
        if (result) {
            dispatch(setCouponsToMyChargeEmployeesHistoryPartial({totalItems: result.totalCount, items: result.items, requestId}));
            let employeesIds: any[] = []
            for (let i = 0; i < result.items.length; i++) {
                const coupon = result.items[i];
                if (!employeesIds.includes(coupon.EmployeeCode)) {
                    employeesIds.push(coupon.EmployeeCode)
                }
                if (!employeesIds.includes(coupon.ApproverCode)) {
                    employeesIds.push(coupon.ApproverCode)
                }
            }
            const newRequestId = requestId === COUPONS_TO_MY_CHARGE_HISTORY_ONE
                ? PENDING_COUPONS_EMPLOYEES_HISTORY_ONE
                :  requestId === COUPONS_TO_MY_CHARGE_HISTORY_TWO 
                    ? PENDING_COUPONS_EMPLOYEES_HISTORY_TWO
                    : PENDING_COUPONS_EMPLOYEES_HISTORY_THREE;
            await getEmployeesAdditionalDataById(
                newRequestId, 
                employeesIds
            )

            
        } else {
            dispatch(setCouponsToMyChargeEmployeesLoading({loading: false, requestId,}));
        }
    }
}


export const approveCoupon = (couponData: (S10CouponsToMyChargePartial & CompanyEmployees), requestId: CouponsToMyChargeRequestId) => {
	const {couponToApproveLoading} = store.getState().userRequests[requestId];
    return async (dispatch: Dispatch) => {
        if (couponToApproveLoading) {
            return;
        }
        dispatch(setCouponsToApprove({data: couponData, requestId}));
        await setAproveCouponERP(couponData)
    }
}


export const searchInMyChargeEmployeesContracts = (
    requestId: InMyChargeEmployeeContractsRequestId, 
	employeeCodes: string,
    rucSelected: string,
    filter: InMyChargeEmployeeContractsRequestFilter,
    description: string,
    pageSize: number,
    page: number,
) => {
    return async (dispatch: Dispatch) => {
        dispatch(setInMyChargeEmployeeContractsReset(requestId));
        dispatch(setInMyChargeEmployeeContractsLoading({loading: true, requestId,}));
        const finalRuc = rucSelected === 'all' ? '' : rucSelected;
        await setEmployeesContractsData(
            requestId, 
            employeeCodes,
            finalRuc,
            filter,
            description,
            pageSize,
            page,
        );
    }
}


export const searchInMyChargeEmployeesPaymentSlips = (
    requestId: InMyChargeEmployeePaymentSlipsRequestId, 
    ruc: string,
	employeeCodes: string,
    filter: InMyChargeEmployeePaymentSlipsRequestFilter,
    description: string,
    pageSize: number,
    page: number,
) => {
    return async (dispatch: Dispatch) => {
        dispatch(setInMyChargeEmployeePaymentSlipsReset(requestId));
        dispatch(setInMyChargeEmployeePaymentSlipsLoading({loading: true, requestId,}));
        await setEmployeesPaymentSlipsData(
            requestId, 
            ruc,
            employeeCodes,
            filter,
            description,
            pageSize,
            page,
        );
    }
}


export const searchInMyChargeEmployeesDocuments = (
    requestId: InMyChargeEmployeeDocumentsRequestId,
    ruc: string,
	employeeCodes: string,
    filter: InMyChargeEmployeeDocumentsRequestFilter,
    description: string,
    pageSize: number,
    page: number,
) => {
    return async (dispatch: Dispatch) => {
        dispatch(setInMyChargeEmployeeDocumentsReset(requestId));
        dispatch(setInMyChargeDocumentsLoading({loading: true, requestId,}));
        await setEmployeesDocumentsData(
            requestId, 
            ruc,
            employeeCodes,
            filter,
            description,
            pageSize,
            page,
        );
    }
}


export const searchEmployeeCalendarEvents = () => {
    return async (dispatch: Dispatch) => {
        await getYearHolidays();
        const employeeEvent = await getEmployeeCoupons({
            page: 1,
            quantity: 1000,
            startDate: `${new Date().getFullYear()}-01-01`,
            endDate: `${new Date().getFullYear()}-12-31`,
            status: '-1',
            couponId: 0,
        })
        if (employeeEvent.data?.Data?.length) {
            const coupons: EmployeCoupons[] = employeeEvent.data?.Data;
            console.log("searchEmployeeCalendarEvents", employeeEvent.data?.Data)
            const desglosedEvents = desgloseEventsByDay(coupons, 'coupons', 'RangeDateInfo')
                                    .map((e) => {
                                        
                                        // const date = new Date(e.customDate);
                                        const utcDate = getDatestring(e.customDate);
                                        return {
                                            ...e,
                                            oldRangeDateInfo: e.RangeDateInfo,
                                            utcDate: utcDate,
                                            customDate: `${getDatestring(utcDate, '-', true)} 12:00:00`,
                                            RangeDateInfo: `${getDatestring(utcDate, '/', false)} 12:00:00`,

                                        }
                                    });
            dispatch(setCalendarEvents({data: desglosedEvents}))
            
        }
    }
}